"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowUpdatePayloadFactoryFromJS = exports.WindowUpdatePayloadFactory = void 0;
const immutable_1 = require("immutable");
const pluginManager_1 = require("../../../../pluginManager");
exports.WindowUpdatePayloadFactory = (0, immutable_1.Record)({
    id: null,
    newId: null,
    isModified: null,
    isNewVersion: null,
    showLoading: null,
    title: null,
    position: null,
    animationClass: null,
    child: null,
    subTitle: null,
    projectSecretKey: null,
    remakeContentHash: null
});
const WindowUpdatePayloadFactoryFromJS = function (data) {
    return (0, exports.WindowUpdatePayloadFactory)(Object.assign(Object.assign({}, data), { child: (0, pluginManager_1.WindowChildFactoryFromJS)(data.child) }));
};
exports.WindowUpdatePayloadFactoryFromJS = WindowUpdatePayloadFactoryFromJS;
//# sourceMappingURL=IUpdatePayload.js.map